import React,{useEffect} from 'react'
import '../PageCss/NewsEvent.css'
import SideNavNewsEvents from '../components/SideNavNewsEvents'
import { useAappContext } from '../context/AppContext'
import { useParams } from 'react-router-dom'
import {SingelNewEvent, NewsTitle} from '../components/SingelNewEvent'

const NewsEvent = () => {
  let newsid=useParams()
   const {getApiData, apiData,isLoadingApiData, getNewsEvent,getNewsEventData}=useAappContext()
      useEffect(()=>{
          getApiData('/newsevent_articale/')
          getNewsEvent('/newsevent/')
      },[])

if (isLoadingApiData){
  <h3>Data Is Loading ..............</h3>
}
 
  return (
    <section id="newevent" className='section-m1 section-p1'>
        <div className="newevent">
          
        <div id='page-title' className="title-yellow">
           <span>Job Placement</span>
          </div>



          <div className="page-title">
          <div className="title-content-1" style={{backgroundColor:'yellowgreen',}}></div>
            <div className="title-content-2" style={{backgroundColor:'red',}}>News & Event</div>
            <div className="title-content-4"></div>
          </div>
          <div className="newevent-content">
            <div className="newsevent-title">
             {
              getNewsEventData.map((cruElem)=>{
                return(
                  <>
                  {cruElem.id== newsid.ne_id ? <NewsTitle key={cruElem.id} {...cruElem} ></NewsTitle> : ""}
                  </>
                )
              })
             }
             
            </div>
          {
            apiData.map((props)=>{
              const{newsEvent:newid}=props;
              return ( 
                <>
                {newid == newsid.ne_id ? <SingelNewEvent key={props.id} {...props}/> : ""}
               </>
              )
            })
          }
          </div>
        </div>
        <SideNavNewsEvents/>
      
    </section>
  )
}

export default NewsEvent